export default {
  worldPriceTitle: "مخطط أسعار العملات المشفرة العالمي",
  description:
    "هذا المخطط لا يعتمد على أسعار Excoino وهو فقط لعرض اتجاهات أسعار العملات المشفرة العالمية."
};
